import React from 'react'
import PropTypes from 'prop-types'
import {matchPath} from 'react-router'
import {Link} from 'react-router-dom'
import {Menu, Button, notification} from 'antd'
import {HomeOutlined, UserOutlined, CheckOutlined, DollarCircleOutlined, FileTextOutlined} from '@ant-design/icons'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import moment from 'moment'

import Logo from 'assets/logo.svg'
import CalendarDownloadIcon from 'assets/icons/calendar-download.svg'
import CalendarIcon from 'assets/icons/calendar.svg'

const CreateCalendarEntriesMutation = gql`
  mutation CreateCalendarEntries($input: CreateCalendarEntriesInput!) {
    CreateCalendarEntries(input: $input) {
      clientMutationId
      url
    }
  }
`

class Navigation extends React.Component {
  state = {
    selected: null,
    showAccountSwitcher: false,
  }

  logout = () => {
    // ideally we'd also like to clear the session in the backend
    localStorage.clear()
    window.location.href = ''
  }

  toggleCollapse = () => {
    if (this.props.toggleCollapse) {
      this.props.toggleCollapse()
    }
  }

  sync = (mutation) => mutation({
    variables: {
      input: {
        from: moment().startOf('day')
      },
    },
  })

  mutationComplete = (data) => {
    this.toggleCollapse()

    const url = data.CreateCalendarEntries.url
    if (url) {
      window.location.href = url
    }
    else {
      notification['error']({
        message: 'Ingen bookinger funnet',
        description: 'Fant ingen fremtidige bookinger.',
      })
    }
  }

  mutationError = () => {
    this.toggleCollapse()

    notification['error']({
      message: 'Kunne ikke synce bookinger',
      description: 'Kunne ikke synce dine bookinger grunnet en feil. Forsøk på nytt senere eller kontakt EFKT kundeservice.',
    })
  }

  render() {
    const routes = [
      {label: 'Min oversikt', path: '/overview', icon: <HomeOutlined />},
      {label: 'Profil', path: '/profile', icon: <UserOutlined />},
      {label: 'Bookinger', path: '/bookings', icon: <CheckOutlined />},
      {label: 'Tilgjengelighet', path: '/availability', icon: <img src={CalendarIcon} alt="" className="menu-icon" />},
      {label: 'Honorarer', path: '/invoicelines', icon: <DollarCircleOutlined />},
      {label: 'Fakturaer', path: '/invoices', icon: <FileTextOutlined />}
    ]

    const selectedPaths = routes
      .map(r => r.path)
      .filter(path =>
        matchPath(this.props.location.pathname, {path})
      )

    return (
      <React.Fragment>
        <Menu
          mode="inline"
          selectedKeys={selectedPaths}
        >
          {routes.map(({label, path, icon}) =>
            <Menu.Item key={path}>
              <Link to={path} onClick={this.toggleCollapse}>
                {icon}
                <span>{label}</span>
              </Link>
            </Menu.Item>
          )}
          <Menu.Item key="sync">
            <Mutation
              mutation={CreateCalendarEntriesMutation}
              onCompleted={this.mutationComplete.bind(this)}
              onError={this.mutationError.bind(this)}
            >
              {(createCalendarEntries) => (
                <div onClick={this.sync.bind(this, createCalendarEntries)}>
                  <img src={CalendarDownloadIcon} alt="" className="menu-icon" />
                  <span>Sync alle bookinger</span>
                </div>
              )}
            </Mutation>
          </Menu.Item>
        </Menu>
        <img src={Logo} alt="EFKT" className="menu-logo" />
        <div className="logout-container">
          <Button block={true} onClick={this.logout}>Logg ut</Button>
        </div>
      </React.Fragment>
    )
  }
}

Navigation.propTypes = {
  location: PropTypes.object.isRequired,
  toggleCollapse: PropTypes.func,
}

export default Navigation
